/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Meta_TitleInputs */

const en_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Us | Alchema`)
};

const de_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ueber uns | Alchema`)
};

const fr_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos | Alchema`)
};

const es_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre nosotros | Alchema`)
};

const it_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi siamo | Alchema`)
};

const nl_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over ons | Alchema`)
};

const pl_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nas | Alchema`)
};

const fi_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoa meistä | Alchema`)
};

const da_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om os | Alchema`)
};

const sv_about_meta_title = /** @type {(inputs: About_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om oss | Alchema`)
};

/**
* | output |
* | --- |
* | "About Us \| Alchema" |
*
* @param {About_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_meta_title = /** @type {((inputs?: About_Meta_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Meta_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_meta_title(inputs)
	if (locale === "fr") return fr_about_meta_title(inputs)
	if (locale === "es") return es_about_meta_title(inputs)
	if (locale === "it") return it_about_meta_title(inputs)
	if (locale === "nl") return nl_about_meta_title(inputs)
	if (locale === "pl") return pl_about_meta_title(inputs)
	if (locale === "fi") return fi_about_meta_title(inputs)
	if (locale === "da") return da_about_meta_title(inputs)
	if (locale === "sv") return sv_about_meta_title(inputs)
	return en_about_meta_title(inputs)
});